import axios from 'axios';
import { z } from 'zod';
import { pcmpSkippedProposalSchema, type PcmpSkippedProposal } from '../types/pcmpQueue.types';

const skippedDetailsSchema = z.object({
  details: z.object({ skipped: z.array(pcmpSkippedProposalSchema) }),
});

/**
 * The proposals a bulk request call left out when it refused as a whole (409):
 * the API lists each with its reason in `details.skipped`. Null for any other error.
 */
export function extractSkippedProposals(error: unknown): PcmpSkippedProposal[] | null {
  if (!axios.isAxiosError(error)) return null;
  const parsed = skippedDetailsSchema.safeParse(error.response?.data);
  return parsed.success && parsed.data.details.skipped.length > 0
    ? parsed.data.details.skipped
    : null;
}

/**
 * The proposals a refused publish names (409): the API puts them in the message as
 * "#<id> it is on hold; #<id> Accounts is no longer pending on it", not as a list.
 */
export function extractBlockingProposalIds(error: unknown): number[] {
  if (!axios.isAxiosError(error)) return [];
  const message = (error.response?.data as { message?: unknown } | undefined)?.message;
  if (typeof message !== 'string') return [];
  const ids = [...message.matchAll(/#(\d+) (?:it |Accounts )/g)].map((match) => Number(match[1]));
  return [...new Set(ids)];
}
